<template>
  <div>
      <AppHeader title="General Reports" />
      <div class="container-fluid">
        <div class="container-fluid left">
          <div class="row" style="padding-left: 15px">
            <!-- <div class="col-sm-1">
              <div
                class="dropdown"
                style="
                  position: fixed;
                  left: 0;
                  top: 0;
                  padding: 0;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <ReportsMenu />
              </div>
            </div> -->
            <div v-if="!loading">
              <div style="color: #fff" class="header-section">
                <h1>{{ listNameDisplay }}</h1>
                <!-- <button class="btn btn-primary text-white leftBut" @click="navigateBack">
            {{ adminLabels("backBut") }}
          </button> -->
              </div>

              <!-- Filter Section -->
              <div
                id="filterbox"
                style="
                  display: flex;
                  align-items: end;
                  justify-content: space-between;
                "
                class="filter_wrapper"
              >
                <div
                  v-for="column in filterColumns"
                  :key="column.fieldname"
                  class="filterbox"
                >
                  <label>{{ column.title }}</label>
                  <input
                    :type="column.typeoffilter == 'D' ? 'date' : 'text'"
                    :id="'col-' + column.fieldname"
                    :data-filter-name="column.fieldname"
                    class="filter-inp form-control"
                    @keyup.enter="setFilter"
                  />
                </div>
                <button
                  class="btn btn-success search-btn"
                  @click="searchGlobalFilter"
                >
                  Search
                </button>
                <button
                  class="btn btn-primary clear-btn text-white"
                  @click="clearFilters"
                >
                  Clear
                </button>
              </div>

              <!-- Buttons Section -->
              <div
                id="buttons-box"
                style="margin-top: 1rem;display: flex;justify-content: end;align-items: center;"
                class="buttons_wrapper"
              >
                <button
                  v-for="button in buttons"
                  :key="button.actioncode"
                  class="btn btn-success action-btn"
                  style="margin: 0 .4rem"
                  :data-action="button.actioncode"
                  @click="handleButtonAction(button.actioncode)"
                >
                  {{ button.name }}
                </button>
              </div>

              <br>
              <!-- Table Section -->
              <div class="table-responsive table-wrap" style="max-height: 60vh !important;">
                <table class="table table-striped">
                  <thead>
                    <tr style="color: white">
                      <th
                        v-for="column in displayColumns"
                        :key="column.fieldname"
                        @click="sortColumn(column.fieldname)"
                      >
                        {{ column.title }}
                        <span v-if="sort.fieldname === column.fieldname">
                          <span v-if="sort.by === 'ASC'">🔼</span>
                          <span v-if="sort.by === 'DESC'">🔽</span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in data" :key="row.id">
                      <td v-for="column in displayColumns" :key="column.fieldname">
                        {{ row[column.fieldname] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination -->

              <ul class="pagination">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" href="#" @click="changePage(currentPage - 1)"
                    >Previous</a
                  >
                </li>

                <li v-if="currentPage > 3">
                  <a class="page-link" href="#" @click="changePage(1)">1</a>
                </li>

                <li v-if="currentPage > 4">
                  <span class="page-link">...</span>
                </li>

                <li
                  v-for="pageNumber in visiblePages"
                  :key="pageNumber"
                  :class="{ active: currentPage === pageNumber }"
                >
                  <a class="page-link" href="#" @click="changePage(pageNumber)">{{
                    pageNumber
                  }}</a>
                </li>

                <li v-if="currentPage < totalPages - 3">
                  <span class="page-link">...</span>
                </li>

                <li v-if="currentPage < totalPages - 2">
                  <a class="page-link" href="#" @click="changePage(totalPages)">{{
                    totalPages
                  }}</a>
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: currentPage === totalPages }"
                >
                  <a class="page-link" href="#" @click="changePage(page + 1)"
                    >Next</a
                  >
                </li>
              </ul>
              <!-- <div id="pagination-div">
                <button
                  v-for="page in totalPages"
                  :key="page"
                  @click="changePage(page)"
                  :class="{ active: page === currentPage }"
                >
                  {{ page }}
                </button>
              </div> -->
            </div>
            <div
              v-else
              class="col-sm-11"
              style="
                color: white;
                min-height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              Loading....
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import commonServices from "@/shared/commonServices";
// import ReportsMenu from "@/components/ReportsMenu";
import AppHeader from "@/components/AppHeader.vue";
import axios from "axios";
import * as XLSX from "xlsx";
import App from "@/src/App.vue";

export default {
  mixins: [commonServices],
  components: { AppHeader },
  data() {
    return {
      listname: "",
      listNameDisplay: "",
      data: [],
      loading: true,
      columns: [],
      buttons: [],
      sort: { fieldname: null, by: "ASC" },
      filters: {},
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: 20,
    };
  },
  computed: {
    visiblePages() {
      let startPage = Math.max(1, this.currentPage - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    displayColumns() {
      return this.columns.filter((col) => col.display === 1);
    },
    filterColumns() {
      return this.columns.filter((col) => col.filter === 1);
    },
  },
  async mounted() {
    this.listname = this.$route.query.listname;
    await this.getInit();
  },
  methods: {
    async getInit() {
      this.columns = await this.getColumns();
      this.buttons = await this.getButtons();
      await this.loadData();
    },
    async loadData() {
      this.loading = true;
      this.data = await this.getData();
      this.loading = false;
    },
    async getColumns() {
      const response = await axios.post(this.apiURL + "/Reports/filter", {
        listname: this.listname,
        listtype: "column",
      });
      this.listNameDisplay = response.data.listname || "";
      return response.data.columns || [];
    },
    async getData(count=0) {
      const response = await axios.post(this.apiURL + "/Reports/filter", {
        listname: this.listname,
        listtype: "data",
        filter: this.filters,
        pageNumber: this.currentPage,
        listcount: count != 0 ? count : this.itemsPerPage,
      });
      this.totalPages = Math.ceil(response.data.totalrows / this.itemsPerPage);
      console.log(this.totalPages);
      return response.data.results || [];
    },
    async getButtons() {
      const response = await axios.post(this.apiURL + "/Reports/filter", {
        listname: this.listname,
        listtype: "buttons",
      });
      return response.data.buttons || [];
    },
    changePage(page) {
      this.currentPage = page;
      this.loadData();
    },
    setFilter(event) {
      this.filters[event.target.dataset.filterName] = `%${event.target.value}%`;
      this.loadData();
    },
    searchGlobalFilter() {
      this.loadData();
    },
    clearFilters() {
      this.filters = {};
      this.loadData();
    },
    sortColumn(field) {
      this.sort = {
        fieldname: field,
        by: this.sort.by === "ASC" ? "DESC" : "ASC",
      };
      this.loadData();
    },
    async handleButtonAction(action) {
      if (action === "ExportExcel") {
        const data = await this.getData(99999999999);
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        XLSX.writeFile(workbook, `${this.listNameDisplay}.xlsx`);
      }
      if (action === "PrintPdf") {
        this.printReport();
      }
    },
    async printReport() {
      const data = await this.getData(99999999999);
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = (nowDate.getMonth() + 1).toString().padStart(2, "0");
      let day = nowDate.getDate().toString().padStart(2, "0");
      let hours = nowDate.getHours().toString().padStart(2, "0");
      let minutes = nowDate.getMinutes().toString().padStart(2, "0");
      let seconds = nowDate.getSeconds().toString().padStart(2, "0");

      let reportHeader = `<h2>Report: ${this.listNameDisplay}</h2>`;
      let reportFooter = `<p>Printed on: ${year}-${month}-${day} ${hours}:${minutes}:${seconds}</p>`;

      // Create table headers
      let tableHeaders = this.displayColumns
        .map((column) => `<th>${column.title}</th>`)
        .join("");

      // Create table rows
      let tableRows = data
        .map((row, index) => {
          let rowData = this.displayColumns
            .map((column) => `<td>${row[column.fieldname]}</td>`)
            .join("");
          return `<tr class="${
            index % 2 === 0 ? "even" : "odd"
          }">${rowData}</tr>`;
        })
        .join("");

      let table = `
    <table>
      <thead><tr>${tableHeaders}</tr></thead>
      <tbody>${tableRows}</tbody>
    </table>
  `;

      
  const viaInvStr = ` <html>
    <head>
      <title>Print Report</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid black; padding: 8px; text-align: left; }
        th { background-color: #f2f2f2; }
        .even { background-color: #f9f9f9; }
        .odd { background-color: #ffffff; }
      </style>
    </head>
    <body>
      ${reportHeader}
      ${table}
      ${reportFooter}
    </body>
    </html>
  `;
    this.sharedPrintElemmRep(viaInvStr);
    },
  },
};
</script>

<style scoped>
label {
  color: #fff;
}
.table-striped tbody tr:nth-child(even) td {
  color: #fff;
}
#pagination-div {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
#pagination-div button {
  background: var(--theme-primary);
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 5px;
  cursor: pointer;
  border-radius: 5px;
}
#pagination-div button.active {
  background: #0056b3;
  font-weight: bold;
}
#pagination-div button:hover {
  background: #0056b3;
}
</style>
